import React from "react";
import "./privacy.css";

const Privacy = () => {
  return (
    // <div className="container privacy">
    //   <div className="row">
    <div className="privacy">
      <h4 className="title_text mt-2">Privacy Policy</h4>
      <p className="update-status">Last Updated: August 30, 2022.</p>
      <ul className="privacy-list">
        <li>
          <h5 className="privacy-title">1. Lorem ipsum</h5>
          <p>
            Nulla Lorem mollit cupidatat irure. Laborum magna nulla duis ullamco
            cillum dolor. Voluptate exercitation incididunt aliquip deserunt
            reprehenderit elit laborum. Nulla Lorem mollit cupidatat irure.
            Laborum magna nulla duis ullamco cillum dolor. Voluptate
            exercitation incididunt aliquip deserunt reprehenderit elit laborum.
            Laborum magna nulla duis ullamco cillum dolor. Voluptate
            exercitation incididunt aliquip deserunt reprehenderit elit laborum.
            Nulla Lorem mollit cupidatat irure. Laborum magna nulla duis ullamco
            cillum dolor. Voluptate exercitation incididunt aliquip deserunt
            reprehenderit elit laborum. Nulla Lorem mollit cupidatat irure.
          </p>
          <p>
            Laborum magna nulla duis ullamco cillum dolor. Voluptate
            exercitation incididunt aliquip deserunt reprehenderit elit laborum.
            Nulla Lorem mollit cupidatat irure. Laborum magna nulla duis ullamco
            cillum dolor. Voluptate exercitation incididunt aliquip deserunt
            reprehenderit elit laborum. Nulla Lorem mollit cupidatat irure.
          </p>
        </li>
        <li>
          <h5 className="privacy-title">2. Lorem ipsum</h5>
          <p>
            Nulla Lorem mollit cupidatat irure. Laborum magna nulla duis ullamco
            cillum dolor. Voluptate exercitation incididunt aliquip deserunt
            reprehenderit elit laborum. Nulla Lorem mollit cupidatat irure.
            Laborum magna nulla duis ullamco cillum dolor. Voluptate
            exercitation incididunt aliquip deserunt reprehenderit elit laborum.
            Nulla Lorem mollit cupidatat irure. Laborum magna nulla duis ullamco
            cillum dolor. Voluptate exercitation incididunt aliquip deserunt
            reprehenderit elit laborum.
          </p>
        </li>

        <li>
          <h5 className="privacy-title">3. Lorem ipsum</h5>
          <p>
            Nulla Lorem mollit cupidatat irure. Laborum magna nulla duis ullamco
            cillum dolor. Voluptate exercitation incididunt aliquip deserunt
            reprehenderit elit laborum. Nulla Lorem mollit cupidatat irure.
            Laborum magna nulla duis ullamco cillum dolor.
          </p>
          <p>
            Voluptate exercitation incididunt aliquip deserunt reprehenderit
            elit laborum. Nulla Lorem mollit cupidatat irure. Laborum magna
            nulla duis ullamco cillum dolor. Voluptate exercitation incididunt
            aliquip deserunt reprehenderit elit laborum. Nulla Lorem mollit
            cupidatat irure. Laborum magna nulla duis ullamco cillum dolor.
            Voluptate exercitation incididunt aliquip deserunt reprehenderit
            elit laborum. Nulla Lorem mollit cupidatat irure. Laborum magna
            nulla duis ullamco cillum dolor. Voluptate exercitation incididunt
            aliquip deserunt reprehenderit elit laborum.
          </p>
        </li>
      </ul>
    </div>
    //    </div>
    // </div>
  );
};

export default Privacy;
